import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import SmartImage from '@/components/base/SmartImage';
import { productCategories } from '@/mocks/productsData';
import { getCategoryImagePath, getProductsByCategory } from '@/pages/products/productUtils';

export default function CategoryGrid() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {productCategories.map((category, index) => (
            <Reveal key={category.id} delay={(index % 3) * 100}>
              <Link
                to={`/products/${category.id}`}
                className="group h-full flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
              >
                <div className="relative w-full h-52 bg-background-100 overflow-hidden flex items-center justify-center">
                  <SmartImage
                    preferredSrc={getCategoryImagePath(category.id)}
                    fallbackSrc={category.image}
                    alt={`${category.title} by Best Research Pharma`}
                    title={`${category.title} - Best Research Pharma`}
                    className="max-h-[80%] max-w-[80%] object-contain transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute top-4 left-4 w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                    <i className={`${category.icon} text-lg`}></i>
                  </span>
                </div>
                <div className="flex flex-col flex-1 p-5 md:p-6">
                  <div className="flex items-center justify-between gap-3">
                    <h3 className="font-heading text-xl font-semibold text-foreground-950">{category.name}</h3>
                    <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-[11px] font-semibold whitespace-nowrap">
                      {getProductsByCategory(category.id).length} products
                    </span>
                  </div>
                  <p className="mt-1.5 text-xs font-semibold uppercase tracking-wide text-primary-600">
                    {category.tagline}
                  </p>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600 flex-1">{category.description}</p>
                  <span className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-primary-700 group-hover:text-primary-600 transition-colors">
                    View Products
                    <i className="ri-arrow-right-line text-base"></i>
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}